import * as swcHelpers from '@swc/helpers';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { getLocalizedValue, getAttrValue, getLocalizedAttrValue } from '@grandvisionhq/utils';
import { getDiscount } from '../../utils/get-discount.js';
import { getPrice } from '../../utils/get-price.js';
import { getProductTag } from '../../utils/get-product-tag.js';

function getVariantInfo(locale, product, variant, productType) {
    const isLenses = CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType);
    const isSolutions = CommerceToolsApi.isSolutions(productType);
    const brand = isLenses || isSolutions ? getLocalizedValue(product.name, locale) : String(getAttrValue(variant, 'brand'));
    const name = isLenses ? getLocalizedAttrValue(variant, 'replacementFrequency', locale) : isSolutions ? `${getLocalizedAttrValue(variant, 'contactLensCareType', locale) || ''} ${getAttrValue(variant, 'packageOption') || ''}` : variant.name;
    const { originalPrice , discountedPrice  } = getPrice(variant.prices) || {};
    const framePriceIncluded = CommerceToolsApi.isFrames(productType) && getAttrValue(variant, 'priceIncluded');
    const price = framePriceIncluded && typeof framePriceIncluded === 'object' ? Number(framePriceIncluded.centAmount) : originalPrice;
    const bestPrice = variant.bestPrice;
    return swcHelpers.objectSpread({
        brand: brand || '',
        discounted: getDiscount(variant.prices, locale),
        name: name || '',
        sku: variant.sku,
        price,
        pricePerUnit: variant.pricePerUnit,
        tag: getProductTag(variant, locale)
    }, discountedPrice && discountedPrice !== originalPrice ? {
        discountedPrice
    } : {}, {
        bestPrice
    });
}

export { getVariantInfo };
//# sourceMappingURL=get-variant-info.js.map
